<template>
  <transition
    name="fade"
    :mode="mode"
  >
    <slot />
  </transition>
</template>

<script lang="ts" setup>
defineProps({
  mode: {
    type: String,
    default: 'out-in',
    validator: (mode: string) => ['in-out', 'out-in'].includes(mode),
  },
});
</script>
